<template>
  <CHeader fixed withSubHeader light>
    <CToggler
    in-header
    class="ml-3 d-lg-none"
    @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      v-if="$route.name != 'Demo'"
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/home">
      <img src="../assets/images/logo-wide-white.png" class="logo-cctv" alt="">
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <!--<img v-if="$route.name == 'Demo'" class="logo-cctv" src="../assets/images/logo-wide-white.png" alt="">
        <CHeaderNavLink :to="{ name: 'Dashboard'}">
          Menu Utama
        </CHeaderNavLink>-->
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav class="mr-2">
      <CHeaderNavItem>
        <CButton
          size="sm"
          class="btn-icon p-0 custom-button-white"
          title="Logout"
          @click="showLogoutModal = true"
        >
          <CIcon name="cil-account-logout" class="mt-0 mb-1"/>
        </CButton>
      </CHeaderNavItem>
    </CHeaderNav>
    <b-modal
      v-model="showLogoutModal"
      no-close-on-backdrop
      no-close-on-esc
      centered
      title="Logout"
      hide-header-close
      hide-footer
      scrollable
      size="sm"
    >
      <CRow>
        <CCol class="col-12">
          <p>Anda yakin ingin logout ?</p>
        </CCol>
      </CRow>
      <CRow class="mt-2 float-right">
        <CCol class="col-12">
          <b-btn variant="secondary" class="mr-3" @click="showLogoutModal = false">Cancel</b-btn>
          <b-btn variant="primary" type="submit" style="width:6rem" @click="doLogout()">
            Logout
          </b-btn>
        </CCol>
      </CRow>
    </b-modal>
  </CHeader>
</template>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
  .btn-icon {
    width: 2rem;
    min-width: 2rem;
  }
</style>


<script>
    import moment from 'moment';
    export default {
      name: "TheHeader",
      components: {
      },
      props: {
        isLoggedIn: {
          type: Boolean,
          default: false
        }
      },
      data(){
        return {
          userName: "",
          showLogoutModal: false,
        }
      },
      methods: {

        generateTime(createdAt) {
          return moment(createdAt, 'DD-MM-YYYY HH:mm').fromNow()
        },

        doLogout() {
          localStorage.setItem('fimsAction', 'logout')
          this.$emit("logout")
        },
      },
      created(){
        this.userName = localStorage.getItem(this.$userNameKeyword)

        moment.updateLocale("id", { week: {
          dow: 1, // First day of week is Monday
          doy: 4  // First week of year must contain 4 January (7 + 1 - 4)
        }})
      },
    }
</script>

<style>

</style>